import { Avatar, Tooltip } from "@mantine/core";
import { IconUser } from "@tabler/icons-react";
import { useUserAvatarBase64 } from "hooks/useUserAvatarBase64";
import { FC } from "react";
import { useTranslation } from "react-i18next";

interface UserAvatarProps {
  userName: string | undefined;
  avatarId?: string;
  imageUrl?: string;
  size?: number;
  initialsName?: string;
}

const UserAvatar: FC<UserAvatarProps> = ({
  userName,
  avatarId = null,
  imageUrl = null,
  size = 40,
  initialsName,
}) => {
  const { t } = useTranslation("users");
  const avatarBase64 = useUserAvatarBase64(avatarId);

  const avatarSrc = imageUrl ?? avatarBase64 ?? undefined;

  return (
    <Tooltip color="gray.8" label={userName || t("unknownUser")} withArrow>
      <Avatar
        radius="xl"
        size={size}
        src={avatarSrc}
        name={initialsName ?? userName}
        alt="avatar"
        color={"initials"}
      >
        {!userName && (
          <IconUser size={typeof size === "number" ? size * 0.6 : 20} />
        )}
      </Avatar>
    </Tooltip>
  );
};

export default UserAvatar;
